module.exports = __webpack_public_path__ + "static/media/mirusResearch.308a6ebf.svg";